import React, { useState, useEffect } from 'react';

import { useLocation } from 'react-router-dom';

import CustomeTnaimPanelAndTable from './CustomeTnaimPanelAndTable';
import { getTnaimContentData, getTnaimTitleData } from '../../server/ServerFunc';

import jsPDF from 'jspdf';
import html2canvas from "html2canvas";
import SvgIcon from '../../CustomeComponents/SvgIcon';
import { PanelBar, PanelBarUtils } from '@progress/kendo-react-layout';

let dataItems = [];
const flatData = (data) => {
  if (data.length > 0) {
    for (let i = 0; i < data.length; i++) {
      dataItems.push(data[i].id);
    }
    return dataItems;
  }
}

const TnaimInfo = ({ PanelBarItemsExt, isMobile }) => {
  // console.log('PanelBarItemsExt', PanelBarItemsExt);
  const components = PanelBarUtils.mapItemsToComponents(PanelBarItemsExt);
  const [expanded, setExpanded] = useState([`.0`]); //`.${PanelBarItemsExt.length - 1}` 
  const [isControlledOpen, setIsControlledOpen] = useState(false);

  // const [tnaimTitles, setTnaimTitles] = useState([]);
  // const [tnaimContentList, setTnaimContentList] = useState([]); //??
  // const [arrayTnaimData, setArrayTnaimData] = useState([]);
  // const [isMobile, setIsMobile] = useState(false);

  // const search = useLocation().search;

  // useEffect(() => {
  //   const tikNumURL = new URLSearchParams(search).get("TikNum");
  //   getTnaimTitle(tikNumURL);
  //   setIsMobile(window.innerWidth < 768);
  // }, []);

  // const getTnaimTitle = async (tikNum) => {
  //   const tnaimTitlesList = await getTnaimTitleData(tikNum);
  //   if(tnaimTitlesList.length > 0) {
  //     setTnaimTitles(tnaimTitlesList);
  //   } else {
  //     setTnaimTitles([]);
  //   }
  // }

  // useEffect(() => {
  //   const tikNumURL = new URLSearchParams(search).get("TikNum");
  //   if(tnaimTitles.length > 0) {
  //     getTnaimContent(tikNumURL);
  //   }
  // }, [tnaimTitles])

  // const getTnaimContent = async (tikNum) => {
  //   const tnaimList = await getTnaimContentData(tikNum);
  //   console.log('tnaimList', tnaimList)
  //   if(tnaimList.length > 0) {
  //     setTnaimContentList(tnaimList);
  //     createTnaimDictionary(tnaimList)
  //   } else {
  //     setTnaimContentList([]);
  //   }
  // }

  // const createTnaimDictionary = (tnaimDataList) => {
  //   const tnDataList = tnaimDataList;
  //   const tnTitlesList = tnaimTitles;

  //   // Initialize an empty dictionary
  //   const tnaimDictionary = {};

  //   // Iterate over the processes array and populate the dictionary
  //   tnTitlesList.forEach(tnai => {
  //     const { tnaiCode, tnaiTitle, field4 } = tnai; //field4
      
  //     // Find steps related to the current tnaiCode
  //     const relatedSteps = tnDataList.filter(tnaiItem => tnaiItem.sugCode === tnaiCode);

  //     // Add entry to the dictionary
  //     tnaimDictionary[tnaiCode] = {
  //       tnaiTitle,
  //       field4,
  //       tnDataList: relatedSteps
  //     };
  //   });

  //   console.log('tnaimDictionary', tnaimDictionary);

  //   convertDictionaryToSortedArray(tnaimDictionary)
  // }

  // const convertDictionaryToSortedArray = (tDictionary) => {
  //   if (Object.entries(tDictionary).length > 0) {

  //     //1. Convert the dictionary to an array for sorting
  //     const keyValueTnaimArray = [];
  //     for (let key in tDictionary) {
  //       if (tDictionary.hasOwnProperty(key)) {
  //         keyValueTnaimArray.push([key, tDictionary[key]]);
  //       }
  //     }

  //     //2. Sort the array based on the field4
  //     for (let i = 0; i < keyValueTnaimArray.length - 1; i++) {
  //       for (let j = 0; j < keyValueTnaimArray.length - i - 1; j++) {
  //         if (keyValueTnaimArray[j][1].field4 > keyValueTnaimArray[j + 1][1].field4) {
  //           // Swap elements if they are in the wrong order
  //           const temp = keyValueTnaimArray[j];
  //           keyValueTnaimArray[j] = keyValueTnaimArray[j + 1];
  //           keyValueTnaimArray[j + 1] = temp;
  //         }
  //       }
  //     }

  //     //3. Insert the sorted array a new array of objects
  //     const sortedTnaimArr = [];
  //     for (let k = 0; k < keyValueTnaimArray.length; k++) {
  //       sortedTnaimArr.push({
  //         tCode: keyValueTnaimArray[k][0],
  //         tTitle: keyValueTnaimArray[k][1].tnaiTitle,
  //         tList: keyValueTnaimArray[k][1].tnDataList,
  //         tField4: keyValueTnaimArray[k][1].field4
  //       })
  //     }
  //     console.log('sortedTnaimArr', sortedTnaimArr);

  //     // setArrayTnaimData(sortedTnaimArr);
  //     displayArrayData(sortedTnaimArr);
  //   } else {
  //     setArrayTnaimData([]);
  //   }
  // }

  // const displayArrayData = (tnainDataArr) => {
  //   const copmToRender = [];
  //   const convertedArray = [];
  //   let countExpend = 0;

  //   console.log('tnainDataArr', tnainDataArr);

  //   if(tnainDataArr.length > 0) {
  //     for (let i = 0; i < tnainDataArr.length; i++) {
  //       const { tCode, tTitle, tList } = tnainDataArr[i];
  //       convertedArray.push({
  //         id: `.${countExpend}`,
  //         title: tTitle,
  //         key: countExpend,
  //         // expanded: countExpend === arrayTnaimData.length - 1 ? true : false,
  //         expanded: countExpend === 0 ? true : false,
  //         content: <CustomeTnaimPanelAndTable key={tCode} tnaiTitle={tTitle} tnaiDataList={tList} isExpend={countExpend}/>
  //       });
  //       copmToRender.push(<CustomeTnaimPanelAndTable key={tCode} tnaiTitle={tTitle} tnaiDataList={tList} isExpend={countExpend} />)
  //       countExpend++;
  //     }
  //   } else {
  //     copmToRender.push(<div style={{ textAlign: "center", margin: "auto" }}>לא נמצאו נתונים</div>);
  //     convertedArray.push({
  //       id: `.${countExpend}`,
  //       title: "",
  //       key: countExpend,
  //       // expanded: countExpend === arrayTnaimData.length - 1 ? true : false,
  //       expanded: true,
  //       content: <div style={{ textAlign: "center", margin: "auto" }}>לא נמצאו נתונים</div>
  //     })
  //   }
    
  //   console.log('convertedArray', convertedArray);
  //   setArrayTnaimData(tnainDataArr);
  //   return copmToRender;
  // }

  const handleExpand = () => {
    setIsControlledOpen(true);
    
    const flattenItemsIds = flatData(PanelBarItemsExt);
    console.log('flattenItemsIds: ', flattenItemsIds);
    setExpanded(flattenItemsIds); // expanded = [".0", ".1", ".2", ".3", ".4", ".5", ".6", ".7"];
    dataItems = [];
  };

  const exportPDF_NG = () => {
    handleExpand();
    
    setTimeout(() => {
      // 1. Save Title as pdf
      const tikDataTitle = document.getElementById("tikToPrint");
      // console.log('tikDataTitle: ', tikDataTitle);
      const pdf = new jsPDF("p", "mm");

      html2canvas(tikDataTitle).then((canvasTitle) => {
        // console.log('canvasTitle', canvasTitle);
        const imgWidth = 190;
        const imgHeight = (canvasTitle.height * imgWidth) / canvasTitle.width;
        let positionY = 10;
        pdf.addImage(canvasTitle, "PNG", 10, positionY, imgWidth, imgHeight, "", "FAST");
      });
      
      //2. Save the table as pdf
      const tableData = document.getElementById("dataToPrint");
      // console.log(tableData);
      html2canvas(tableData).then((canvasTable) => {
        // console.log('canvasTable', canvasTable);
        const imgWidth = 200; //180
        const pageHeight = 295;
        const imgHeight = (canvasTable.height * imgWidth) / canvasTable.width;
        let heightLeft = imgHeight;
        let positionY = 10;
        heightLeft -= pageHeight;

        pdf.addImage(canvasTable, "PNG", 0, positionY + 10, imgWidth, imgHeight, "", "FAST");
        while (heightLeft >= 0) {
          positionY = heightLeft - imgHeight;
          pdf.addPage();
          pdf.addImage(canvasTable, "PNG", 0, positionY + 20, imgWidth, imgHeight, "", "FAST");
          heightLeft -= pageHeight;
        }

        pdf.save(`תנאים לקידום תיק`);
      });
    }, 1000);
  }

  return (
    // <div className="container-item">
    // <div style={{ margin: `${isMobile ? "-104px 0px 0px 0px" : "-130px 0px 0px 0px"}`, backgroundColor: "white" }} >
    // <div className="container my-3 my-lg-5">
    //       {/* {displayArrayData()} */}
    // </div>
    <div className="container my-3 my-lg-5" id="dataToPrint" style={{ marginTop: "50px" }}>
        {
          !isMobile ? 
          <span>
              <SvgIcon icon={"download-doc"} title="ייצוא ל- PDF" onClick={() => exportPDF_NG()} style={{ cursor: "pointer", marginLeft: "5px" }} /> 
              ייצוא ל- PDF
          </span>
            :
            ""
        }
        <PanelBar 
          expandMode="multiple" 
          children={components} 
          isControlled={isControlledOpen}
          expanded={expanded}
          onSelect={() => setIsControlledOpen(false)}
        />
    </div>
  )
}

export default TnaimInfo;